import axios from 'axios';

import catalogConfig from '@/views/Catalog/products.json';
import { buildSectionQuotaOptionsMap } from '@/utils/catalogPricing';
import { groupApiProductsBySection } from '@/utils/catalogProductsApi';

const CATALOG_API_FIELDS = 'id,name,slug,price,price_from,price_range,unit,tags';

const EMPTY_PRODUCTS_BY_SECTION = {
  tests: [],
  analytics: [],
  development: [],
  professionalDevelopment: [],
  expertSupport: [],
};

const getFallbackProductsBySection = () => ({
  tests: catalogConfig.tests ?? [],
  analytics: catalogConfig.analytics ?? [],
  development: catalogConfig.development ?? [],
  professionalDevelopment: catalogConfig.professionalDevelopment ?? [],
  expertSupport: catalogConfig.expertSupport ?? [],
});

const getFallbackQuotaOptionsBySection = () => (
  buildSectionQuotaOptionsMap(getFallbackProductsBySection(), catalogConfig)
);

const normalizeApiProducts = (data) => {
  if (Array.isArray(data)) {
    return data;
  }

  return data?.data ?? data?.products ?? [];
};

export default {
  namespaced: true,

  state: () => ({
    productsBySection: { ...EMPTY_PRODUCTS_BY_SECTION },
    quotaOptionsBySection: getFallbackQuotaOptionsBySection(),
    isLoading: false,
  }),

  mutations: {
    setProductsBySection(state, data) {
      state.productsBySection = data;
    },
    setQuotaOptionsBySection(state, data) {
      state.quotaOptionsBySection = data;
    },
    setLoading(state, data) {
      state.isLoading = data;
    },
  },

  actions: {
    async fetchProducts({ commit }) {
      commit('setLoading', true);

      try {
        await axios
            .get(`${process.env.VUE_APP_SITE_BACK}/api/products/all`, {
              params: { only: CATALOG_API_FIELDS },
              withCredentials: false,
            })
            .then(({ data }) => {
              const groupedProducts = groupApiProductsBySection(normalizeApiProducts(data));

              commit('setProductsBySection', groupedProducts);
              commit(
                  'setQuotaOptionsBySection',
                  buildSectionQuotaOptionsMap(groupedProducts, catalogConfig),
              );
            });
      } catch {
        commit('setProductsBySection', getFallbackProductsBySection());
        commit('setQuotaOptionsBySection', getFallbackQuotaOptionsBySection());
      } finally {
        commit('setLoading', false);
      }
    },
  },
};
